<dgx-components-panel
  [rounded]="'lg'"
  [spacing]="'sm'"
  [variant]="'neutral-transparent-alternative'"
  class="protection-details-purchase-price-option"
>
  <ng-container *ngIf="hasDiscountPrice">
    <div class="protection-details-purchase-price-option__pill-container">
      <us-registration-promotion-pill>
        {{ subscription }}
      </us-registration-promotion-pill>
    </div>
  </ng-container>
  <div class="protection-details-purchase-price-option__title pb-1">
    <p class="protection-details-purchase-price-option__title-text">
      <ng-container *ngIf="hasDiscountPrice">
        <ng-container *ngIf="isPrepayPaymentOption; else monthlyPaymentOption">
          Annually -
          <span
            class="protection-details-purchase-price-option__price-strikethrough"
            >{{ originalPrice }}</span
          >
          {{ discountedPrice }}
        </ng-container>
        <ng-template #monthlyPaymentOption>
          Monthly -
          <span
            class="protection-details-purchase-price-option__price-strikethrough"
            >{{ originalPrice }}</span
          >
          {{ discountedPrice }} a month
        </ng-template>
      </ng-container>

      <ng-container *ngIf="!hasDiscountPrice">
        <ng-container *ngIf="isPrepayPaymentOption; else monthlyPaymentOption">
          Annually - {{ originalPrice }}
        </ng-container>
        <ng-template #monthlyPaymentOption>
          Monthly - {{ originalPrice }} a month
        </ng-template>
      </ng-container>
    </p>
    <ng-container *ngIf="isPrepayPaymentOption">
      <div class="ml-3">
        <dgx-components-badge [spacing]="1" [theme]="'branded-primary'">
          <p class="protection-details-purchase-price-option__title-badge-text">
            {{ newMessage }}
          </p>
        </dgx-components-badge>
      </div>
    </ng-container>
  </div>

  <p
    *ngIf="subtitle"
    class="protection-details-purchase-price-option__subtitle pb-2"
  >
    {{ subtitle }}
  </p>

  <p
    *ngIf="disclaimer"
    class="protection-details-purchase-price-option__disclaimer"
  >
    {{ disclaimer }}
  </p>

  <dgx-components-button
    (clicked)="onButtonClick()"
    [fill]="true"
    [loading]="buttonLoading"
    [variant]="'primary'"
    class="pt-3"
  >
    {{ buttonText }}
  </dgx-components-button>
</dgx-components-panel>
